import { ReactNode } from 'react';

import { useFormContext } from './context';

export function FormProvider({ children }: { children: ReactNode }) {
  useFormContext();

  return children;
}
